import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import queryString from 'query-string';

import { CDAMainViewer, AttachmentViewer } from './container';

const Main = ({
  ehrRecord,
  requestPatientRecord,
  isNewRecordAvailable,
  getPatientAttachment,
  exportCDAAsPDF,
  exportCDAAsPDFLoading,
  setExportCDAAsPDFLoading
}) => {
  const [isAttachment, setIsAttachment] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const params = queryString.parse(searchParams.toString());

    if (params.attachment) {
      setIsAttachment(true);
    } else {
      setIsAttachment(false);
    }
  }, [searchParams, setSearchParams]);

  return (
    <>
      {isAttachment ? (
        <AttachmentViewer getPatientAttachment={getPatientAttachment} />
      ) : (
        <CDAMainViewer
          ehrRecord={ehrRecord}
          requestPatientRecord={requestPatientRecord}
          isNewRecordAvailable={isNewRecordAvailable}
          exportCDAAsPDF={exportCDAAsPDF}
          exportCDAAsPDFLoading={exportCDAAsPDFLoading}
          setExportCDAAsPDFLoading={setExportCDAAsPDFLoading}
        />
      )}
    </>
  );
};

export default Main;
